<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <emp-lookup
            :class-padding="classPadding"
            v-model="selectedEmp"
            label="Employee Code"
            title="Employee"
            :code-value="true"
            :off-remarks="true"
          ></emp-lookup>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="8" :class="classPadding">
          <v-text-field
            label="Name"
            :value="selectedEmp.desc"
            :class="classPadding"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
          <v-select
            label="IR No."
            v-model="selectedIRNo"
            :items="irNos"
            item-text="irNo"
            item-value="irNo"
            :class="classPadding"
          ></v-select>
        </v-col>
        <!-- <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
          <v-select
            label="AWOL"
            v-model="par1"
            :items="letterContents"
            item-text="messageCode"
            item-value="messageCode"
            :class="classPadding"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
          <v-select
            label="Preventive Suspension"
            v-model="par2"
            :items="letterContents"
            item-text="messageCode"
            item-value="messageCode"
            :class="classPadding"
          ></v-select>
        </v-col> -->

        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <emp-lookup
            :class-padding="classPadding"
            v-model="preparedBy"
            label="Prepared By"
            title="Employee"
            :off-remarks="true"
          ></emp-lookup>
        </v-col>
      </v-row>

      <v-row>
        <v-col xs="12" sm="12" md="12" :class="classPadding">
          <v-btn
            outlined
            @click.stop="exportReport"
            :loading="loading"
            :class="classPadding"
            >Export</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
const CustomDatepicker = () => import("../../../components/CustomDatepicker");
const EmpLookup = () =>
  import("../../maintenance/employee-masterfile/personal-info/Lookup");
const DiscCaseLookup = () =>
  import("../../maintenance/employee-other-info/disc-case/Lookup");
import { isNullOrUndefined } from "../../../validation/validation";
const API_ENDPOINT_LETTER = "/api/letterContent";

const API_ENDPOINT = "/api/reports";
export default {
  data: () => ({
    classPadding: "my-0 py-0",
    selectedEmp: {},
    loading: false,
    selectedDiscCase: {},
    memoDate: null,
    reportTemplate: "0",
    letterContents: [],
    par1: null,
    par2: null,
    irNos: [],
    selectedIRNo: null,
    preparedBy: {},
  }),
  components: {
    EmpLookup,
    DiscCaseLookup,
    CustomDatepicker,
  },
  computed: {
    ...mapState("other", ["client"]),
  },
  methods: {
    exportReport() {
      this.loading = true;
      if (this.client == "IBC") {
        var param = {
          EmpCode: this.selectedEmp.code,
          IRNo: this.selectedIRNo,
          MessageCode1: this.par1,
          MessageCode2: this.par2,
          PreparedBy: this.preparedBy.code,
        };
        this.$axios
          .post(`${API_ENDPOINT}/notice-discip-action-ibc`, param)
          .then(({ data }) => {
            var nameOfTheCsv = "NoticeOfDisciplinaryAction.xlsx";
            this.$axios
              .get(`${API_ENDPOINT}/notice-discip-action-ibc/${data}`, {
                responseType: "blob",
              })
              .then((response) => {
                const downloadUrl = window.URL.createObjectURL(
                  new Blob([response.data])
                );
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", nameOfTheCsv);
                document.body.appendChild(link);
                link.click();
                link.remove();
              })
              .catch((err) => console.log(err));
          })
          .catch(({ response }) => {
            this.$toast.error(response.data.message);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        var data = {
          EmpCode: this.selectedEmp.code,
          Ref: this.selectedDiscCase.code,
          MessageCode1: this.par1,
          MessageCode2: this.par2,
          Group: this.reportTemplate,
        };

        var url = `${API_ENDPOINT}/notice-explain`;
        this.$axios
          .post(url, data)
          .then(({ data }) => {
            var subPath = process.env.VUE_APP_PATH;
            window.open(
              `${subPath.slice(0, -1)}/report-viewer?reportCode=${
                data.reportCode
              }&dbName=${data.dbName}&key=${data.key}&companyKey=${
                data.companyKey
              }&reportUrl=${data.url}&client=${data.client}&logoAlign=${
                data.logoAlign
              }&logoWidth=${data.logoWidth}&rpt=${data.rpt}`
            );
          })
          .catch(({ response }) => {
            this.$toast.error(response.data.message);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    getLetterContent() {
      this.$axios
        .get(`/api/letterContent`)
        .then(({ data }) => {
          this.letterContents = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    getIRNos(empCode) {
      this.$axios
        .get(`/api/discCaseMaint/irno/${empCode}`)
        .then(({ data }) => {
          this.irNos = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
  },
  watch: {
    selectedEmp(val) {
      if (!isNullOrUndefined(val.code)) {
        this.getIRNos(val.code);
      } else {
        this.irNos = [];
      }
    },
  },
  created() {
    this.getLetterContent();
  },
};
</script>
